import { Camera, Trash2 } from 'lucide-react';
import { useRef } from 'react';

function FileUploadField({ fileName, onFileChange, onClear }) {
  const inputRef = useRef(null);

  const handleOpenPicker = () => {
    inputRef.current?.click();
  };

  const handleChange = (event) => {
    const file = event.target.files?.[0];

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        onFileChange({
          name: file.name,
          dataUrl: typeof reader.result === 'string' ? reader.result : '',
        });
      };
      reader.readAsDataURL(file);
    }

    event.target.value = '';
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <div className="flex gap-2 overflow-x-auto">
          {fileName ? (
            <div className="flex min-h-[74px] min-w-[132px] items-center justify-between gap-3 rounded-[10px] border border-[#d7dce2] bg-white px-3 py-2 shadow-sm">
              <span className="font-login text-[12px] font-semibold text-[#374151]">
                {fileName}
              </span>
              <button
                type="button"
                onClick={onClear}
                aria-label="Quitar archivo"
                className="text-[#7b8794] transition hover:text-[#253140]"
              >
                <Trash2 className="h-4 w-4" strokeWidth={2.2} />
              </button>
            </div>
          ) : null}
        </div>

        <button
          type="button"
          onClick={handleOpenPicker}
          className="inline-flex h-11 w-11 items-center justify-center rounded-[12px] bg-[#ffffff] text-[#2e2e2e] shadow-[0_3px_10px_rgba(15,23,42,0.16)] transition hover:bg-[#f7f9fc]"
          aria-label="Cargar evidencia"
        >
          <Camera className="h-5 w-5" strokeWidth={2.4} />
        </button>
      </div>

      <input
        ref={inputRef}
        type="file"
        className="hidden"
        onChange={handleChange}
      />
    </div>
  );
}

export default FileUploadField;
